/**
 * Ingilizce katalog — BILINCLI OLARAK BOS taslak.
 *
 * fallbackLng 'tr' oldugu icin eksik her anahtar Turkce metne duser; yarim
 * cevrilmis bir arayuz yerine tutarli Turkce gorunur. Ingilizce gercekten
 * gerektiginde tr.ts yapisi birebir kopyalanip cevrilir (yapi ayni kalmali,
 * yoksa anahtar testleri iki katalogu karsilastiramaz).
 */
const en = {};

export default en;
